"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  NavMenuGroup: true
};
exports.default = exports.NavMenuGroup = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _isString = require("../utils/isString");
var _NavMenuGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./NavMenuGroup.css") : void 0);
var _NavMenuGroup2 = require("./NavMenuGroup.types");
Object.keys(_NavMenuGroup2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NavMenuGroup2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _NavMenuGroup2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const CSS_BLOCK = 'sapcnqr-nav-menu-group';
const NavMenuGroup = exports.NavMenuGroup = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
      header,
      children,
      className,
      wrapperListItemProps,
      headerProps
    } = props,
    groupProps = __rest(props, ["header", "children", "className", "wrapperListItemProps", "headerProps"]);
  const classnames = _bind.default.bind(_NavMenuGroup.default);
  const ariaLabelConstructor = content => {
    let ariaLabelContent;
    if (content) {
      if ((0, _isString.isString)(content)) {
        ariaLabelContent = content;
      } else {
        ariaLabelContent = `${(content === null || content === void 0 ? void 0 : content.title) || ''}${(content === null || content === void 0 ? void 0 : content.description) ? `, ${content.description}` : ''}`;
      }
    }
    return ariaLabelContent;
  };
  let headerContent;
  if ((0, _isString.isString)(header)) {
    headerContent = header;
  } else if ((header === null || header === void 0 ? void 0 : header.title) || (header === null || header === void 0 ? void 0 : header.description)) {
    headerContent = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, header === null || header === void 0 ? void 0 : header.title, (header === null || header === void 0 ? void 0 : header.description) && (/*#__PURE__*/_react.default.createElement("div", {
      className: classnames(`${CSS_BLOCK}__subtitle`)
    }, header.description)));
  }
  return /*#__PURE__*/_react.default.createElement("li", Object.assign({}, wrapperListItemProps, {
    role: "none",
    className: classnames(wrapperListItemProps === null || wrapperListItemProps === void 0 ? void 0 : wrapperListItemProps.className, `${CSS_BLOCK}__wrapper`)
  }), /*#__PURE__*/_react.default.createElement("ul", Object.assign({}, groupProps, {
    role: "group",
    "aria-label": ariaLabelConstructor(header),
    className: classnames(className, `${CSS_BLOCK}`),
    "data-nui-widgets": "menuitem-node",
    ref: ref
  }), headerContent && (/*#__PURE__*/_react.default.createElement("li", Object.assign({}, headerProps, {
    className: classnames(headerProps === null || headerProps === void 0 ? void 0 : headerProps.className, CSS_BLOCK, `${CSS_BLOCK}__header`),
    role: "none",
    "data-nui-widgets": "menuitem-leaf"
  }), headerContent)), children));
});
NavMenuGroup.displayName = 'NavMenuGroup';
var _default = exports.default = NavMenuGroup;